module.exports = __webpack_public_path__ + "img/logo.bc5caee6.png";